import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import { format } from '@mixins/decimal';
import Model from '@models/model';

export default class ProposalMmaMaterial extends Model {
    constructor(...props) {
        super();
        this.item = {};
        this.setAttributes(...props);
    }

    resource() {
        return 'materials';
    }

    get formFieldCasts() {
        return {
            cost: CurrencyFormatter.formFormat,
            price: CurrencyFormatter.formFormat,
        };
    }

    get propCasts() {
        return {
            qty: format,
        };
    }
}
